import script from "./SubscriptionsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionsHeader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__